export default __webpack_public_path__ + "static/media/preflop-equity-handvsrange_0022_thumb.eec77f10.jpg";